import React from 'react';
import CsplLoader from "../../CsplControls/CsplLoader/CsplLoader";
import { StylePropertiesEnum } from "../../../Enumeration/StylePropertiesEnum";

function innerContent(props) {
  return (
    <>
    <div className='d-flex justify-content-center'>
    <span className='pe-3'>
     {props.showLoader &&  <CsplLoader
                            type={StylePropertiesEnum.spin}
                            color={StylePropertiesEnum.Blue}
                            height={StylePropertiesEnum.fifteenPx}
                            width={StylePropertiesEnum.tweentyPx}
                          />}
      </span>
    
    {props.innertext && <span>{props.innertext}</span>}
    
    </div>    
    </>
  )
}

export default innerContent